import { Button } from '@/components/ui/button'
import { useClearDues } from '@/hooks/useClearDues'
import { formatBillingDate } from '@/utils/billingDateUtils'
import { AlertTriangle } from 'lucide-react'

interface AccessRestrictedOverlayProps {
	expirationDate?: string | null
}

export function AccessRestrictedOverlay({ expirationDate }: AccessRestrictedOverlayProps) {
	const handleClearDues = useClearDues()
	const expirationDateStr = expirationDate ? formatBillingDate(expirationDate) : '--'

	return (
		<div className='absolute inset-0 bg-background/50 backdrop-blur-md z-[9999] flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-300'>
			<div className='max-w-md p-6 bg-card border rounded-lg shadow-levitating flex flex-col items-center gap-4'>
				<div className='size-12 rounded-full bg-status-warning-bg flex items-center justify-center text-status-warning-text shrink-0'>
					<AlertTriangle className='size-6' />
				</div>
				<div className='space-y-2'>
					<h3 className='text-form-modal-title font-semibold text-foreground tracking-tight'>Access Restricted</h3>
					<p className='text-body text-muted-foreground leading-relaxed'>
						Your current plan is expired on {expirationDateStr}. Please clear any outstanding dues to restore full
						access to your organization's projects and devices.
					</p>
				</div>
				<Button onClick={handleClearDues} className='w-full mt-2' size='lg'>
					Clear Dues
				</Button>
			</div>
		</div>
	)
}
